import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, ArrowRight } from 'lucide-react';

export function HyroxPredictorCTA() {
  return (
    <div className="my-10 relative overflow-hidden border border-[#e8ff00]/20 bg-[#0a0a0a]" data-testid="hyrox-predictor-cta">
      {/* Grid background */}
      <div className="absolute inset-0 pointer-events-none" style={{
        backgroundImage: 'linear-gradient(rgba(232,255,0,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(232,255,0,0.04) 1px, transparent 1px)',
        backgroundSize: '30px 30px',
      }} />
      {/* Top accent line */}
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, #e8ff00, transparent 70%)' }} />

      <div className="relative p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-6">
        <div className="w-14 h-14 flex items-center justify-center bg-[#e8ff0015] border border-[#e8ff0030] flex-shrink-0">
          <Zap className="w-6 h-6 text-[#e8ff00]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-mono text-[10px] tracking-[0.2em] text-[#e8ff00] uppercase mb-1">Free HYROX Tool</p>
          <h4 className="font-heading text-2xl text-white mb-1">Predict Your HYROX Finish Time</h4>
          <p className="text-sm text-zinc-500 leading-relaxed">Enter your running and station benchmarks to get a predicted finish time with station-by-station splits and race day strategy tips.</p>
        </div>
        <Link
          to="/tools/hyrox-finish-time"
          className="flex-shrink-0 bg-[#e8ff00] text-black font-heading text-sm tracking-[0.1em] px-6 py-3 flex items-center gap-2 hover:bg-white transition-colors"
          data-testid="hyrox-predictor-cta-btn"
        >
          TRY IT FREE <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
